import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api/apiClient';
import { CuentaAdministrativa, NuevaCuenta, Rol } from '../types/identidad';

/** US-08: solo Administrador (el backend rechaza con 403 a Empleado). */
export function useCuentas() {
  return useQuery({
    queryKey: ['cuentas'],
    queryFn: () => apiFetch<CuentaAdministrativa[]>('/cuentas', { autenticado: true }),
  });
}

export function useCrearCuenta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (datos: NuevaCuenta) =>
      apiFetch<CuentaAdministrativa>('/cuentas', { method: 'POST', body: datos, autenticado: true }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['cuentas'] }),
  });
}

export function useCambiarRolCuenta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, rol }: { id: string; rol: Rol }) =>
      apiFetch<CuentaAdministrativa>(`/cuentas/${id}/rol`, {
        method: 'PUT',
        body: { rol },
        autenticado: true,
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['cuentas'] }),
  });
}

export function useEliminarCuenta() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiFetch<void>(`/cuentas/${id}`, { method: 'DELETE', autenticado: true }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['cuentas'] }),
  });
}
